import React, { useState } from "react";
import FormHOC from "./FormHOC";

function MenuItem({ onSelect, data = [], value, FontData }) {
  return (
    <select
      onChange={(e) => onSelect(e.target.value)}
      value={value}
      className="flex-1 border shadow px-5 py-2  text-left rounded-lg outline-none"
      dir="rtl"
    >
      {FontData
        ? FontFamily.map((data, index) => (
            <option
              style={{
                fontFamily: data.fontFamily,
              }}
              value={data.fontFamily}
            >
              {1 + index + "- "} الخط العربي
            </option>
          ))
        : data.map(({ key, value }) => <option value={value}>{key}</option>)}
    </select>
  );
}
function MenuTexture({ onSelect, data = [], value, FontData, color }) {
  const [open, setopen] = useState(false);
  const [txt, setTxt] = useState(value);
  return (
    <div value={value} className=" ">
      <div
        className="flex w-full items-center my-4 cursor-pointer"
        onClick={() => setopen(!open)}
      >
        <div className="border flex-1 px-5 py-2 shadow rounded-l-md">{txt}</div>
        <span className="bg-white rounded-r-md px-5 py-2  shadow border-l-2 border-gray-200">
          {" "}
          إختر السمة
        </span>
      </div>
      <div
        className="rounded-lg outline-none overflow-y-auto h-64 my-5 shadow duration-500 transition-all"
        style={{ height: open ? "29rem" : "0" }}
      >
        {Texture.map((data, index) => (
          <div
            className={`flex w-full justify-between items-center hover:bg-white cursor-pointer px-2 ${
              txt === `bgackground-${data}` ? "bg-gray-200" : ""
            }`}
            style={{
              fontFamily: data.fontFamily,
            }}
            value={`bgackground-${data}`}
            onClick={() => {
              onSelect(`background-${data}`);
            }}
          >
            <div
              className={`background-${data} h-16 w- shadow rounded`}
              style={{
                transform: "scale(0.9)",
                height: "110px",
                width: "16rem",
                backgroundColor: color,
              }}
            ></div>
            <span>{1 + index + "- "}الخلفية</span>
          </div>
        ))}
      </div>
    </div>
  );
}
const Texture = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
];
const FontFamily = [
  { value: "Almarai", fontFamily: "Almarai" + "-Regular" },
  { value: "Cairo", fontFamily: "Cairo" + "-Regular" },
  { value: "ElMessiri", fontFamily: "ElMessiri" + "-Regular" },
  { value: "Katibeh", fontFamily: "Katibeh" + "-Regular" },
  { value: "Lalezar", fontFamily: "Lalezar" + "-Regular" },
  { value: "Rakkas", fontFamily: "Rakkas" + "-Regular" },
  { value: "ReemKufi", fontFamily: "ReemKufi" + "-Regular" },
  { value: "Tajawal", fontFamily: "Tajawal" + "-Regular" },
  { value: "Vibes", fontFamily: "Vibes" + "-Regular" },
  { value: "VIP-Urkida", fontFamily: "VIP-Urkida-Regular" },
  { value: "FFSakhr", fontFamily: "FFSakhr-Regular" },
  { value: "Decotype-Regular", fontFamily: "Decotype-Regular" },
  { value: "Air-Strip-Regular", fontFamily: "Air-Strip-Regular" },
  { value: "Othmani", fontFamily: "Othmani" },
  { value: "BoutrosNewsH1-Bold", fontFamily: "BoutrosNewsH1-Bold" },
  { value: "Monadi", fontFamily: "Monadi" },
  { value: "RAOOF-REAL-SMOOTH", fontFamily: "RAOOF-REAL-SMOOTH" },
  { value: "RAOOF-SLIGHTROUND", fontFamily: "RAOOF-SLIGHTROUND" },
  { value: "Elegant-ar-bold", fontFamily: "Elegant-ar-bold" },
  { value: "Omar-Regular-1", fontFamily: "Omar-Regular-1" },
  { value: "BigVesta-Arabic-Regular", fontFamily: "BigVesta-Arabic-Regular" },
];
export { MenuTexture };
export default FormHOC(MenuItem);
